import { FC } from 'react';

import { CampaignType } from 'utils/constants/campaign';

import Banner from 'components/Banner';

import { Banner as BannerType, FrontendStatusType } from 'store/models/dashboard';

import styles from 'components/CampaignCard/BannersTabs/Banners/Banners.module.less';

interface BannersProps {
    banners: BannerType[];
    campaignStatus: FrontendStatusType;
    campaignId: number;
    vacancyId: number | null;
    advertisingServiceType: CampaignType;
}

const Banners: FC<BannersProps> = ({ banners, campaignId, campaignStatus, advertisingServiceType, vacancyId }) => {
    const bannersCount = banners.length;
    const isOneBannerEnabled = banners.filter((banner) => banner.enabled).length === 1;

    return (
        <div className={styles.banners}>
            {banners.map((banner, key) => (
                <Banner
                    key={key}
                    {...banner}
                    campaignId={campaignId}
                    campaignStatus={campaignStatus}
                    bannersCount={bannersCount}
                    isBannerLastEnabled={isOneBannerEnabled && banner.enabled}
                    advertisingServiceType={advertisingServiceType}
                    vacancyId={vacancyId}
                />
            ))}
        </div>
    );
};

export default Banners;
